import {
  InboxOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Card, Result, Row, Table, Upload, message } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { excelToJsonMapper } from "../../utils/excelToJsonMapper";
import { parseExcelOption } from "../../utils/parseExcelOption";
import { baseurl, baseurlwc, credentials } from "../../api/api";
import { GetTokenProducto } from "../../api/utils";
import { toast } from "react-toastify";

const { Dragger } = Upload;

const stylecard = {
  width: "70vw",
  borderRadius: "12px",
  margin: 10,
  boxShadow: "1px 2px 2px 0px #cccccc",
};

const validateFile = (file) => {
  const isExcel =
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    file.name.toLowerCase().endsWith(".xlsx");

  if (!isExcel) {
    message.error("Solo se permiten archivos Excel con extensión .xlsx");
    return false;
  }

  return true;
};

export const MassUpload = () => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState();
  const [data, setData] = useState([]);

  const [loadingMassive, setLoadingMassive] = useState(false);

  const readExcelFile = (file) => {
    setLoading(true);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        const newJsonData = jsonData.map((item, i) => {
          const product = {
            key: i,
            Codigo: item[excelToJsonMapper.Codigo] || "",
            Descripcion: item[excelToJsonMapper.Descripcion] || "",

            //todo: este 'TipoProducto' es posiblemente 1 siempre porque en Ari es para crear producto
            type: parseExcelOption(item[excelToJsonMapper.TipoProducto])
              .name,
            TipoProducto: 1 ,

            IdCategoria: parseExcelOption(
              item[excelToJsonMapper.IdCategoria]
            ).id,
            Categoria: parseExcelOption(item[excelToJsonMapper.IdCategoria])
              .name,
            IdSubCategoria: parseExcelOption(
              item[excelToJsonMapper.IdSubCategoria]
            ).id,
            SubCategoria: parseExcelOption(
              item[excelToJsonMapper.IdSubCategoria]
            ).name,
            //* Mismo valor para los 3 precios de venta, columna excel "Precion de venta"
            PrecioVentaConIva1: item[excelToJsonMapper.PrecioVentaConIva1],
            PrecioVentaConIva2: item[excelToJsonMapper.PrecioVentaConIva1],
            PrecioVentaConIva3: item[excelToJsonMapper.PrecioVentaConIva1],
            //* Fijo en 0 siempre
            IdIva: 0,
            PorcentajeIva: item[excelToJsonMapper.PorcentajeIva],
            //* Fijo en 1, identificador de que es un producto y no un servicio
            productstore: 1,
            weight: String(item[excelToJsonMapper.weight]),
            brandId: parseExcelOption(item[excelToJsonMapper.brand]).id,
            brandName: parseExcelOption(item[excelToJsonMapper.brand]).name,

            //* Variantes
            // Atributo1: tallas id 1
            // Atributo2: colores id 2
            attributes: [
              {
                id: 1,
                options: (item[excelToJsonMapper.tallas] || '').split(", "),
                variation: true,
                visible: true,
              },
              {
                id: 2,
                options: (item[excelToJsonMapper.colores] || '').split(", "),
                variation: true,
                visible: true,
              }
            ],

            //* Estado para cuando se hagan las peticiones de guardar productos en cargue masivo
            uploadStatus: "pendiente",
          };

          return product;
        });

        setData(newJsonData);

        console.table("@@Datos leídos del Excel:", newJsonData);
        message.success("Archivo procesado correctamente.");
      } catch (error) {
        console.log("error", error);

        message.error("Error al leer el archivo Excel.");
      } finally {
        setLoading(false);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const props = {
    accept:
      ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    name: "file",
    multiple: false,
    maxCount: 1,
    fileList,
    beforeUpload: (file) => {
      if (!validateFile(file)) return Upload.LIST_IGNORE;

      readExcelFile(file);
      setFileList([file]);
      return false;
    },
    onChange(info) {
      const { status } = info.file;
      console.log("status::", status);

      if (status !== "uploading") {
        console.log("Archivo seleccionado:", info.file);
      }

      if (status === "removed") {
        setFileList([]);
        setData([]);
        message.info("Archivo eliminado.");
      }
    },
  };

  const columns = [
    {
      title: "Código",
      dataIndex: "Codigo",
      key: "Codigo",
    },
    {
      title: "Nombre del Producto",
      dataIndex: "Descripcion",
      key: "Descripcion",
    },
    {
      title: "Tipo de producto",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Estado",
      dataIndex: "uploadStatus",
      key: "uploadStatus",
    },
  ];

  const updateDataProductStatus = (index, newStatus) => {
    setData((prevItems) =>
      prevItems.map((item, ix) =>
        ix === index ? { ...item, uploadStatus: newStatus } : item
      )
    );
  };

  const massiveUpload = async () => {
    setLoadingMassive(true);

    const getTokenRes = await GetTokenProducto();
    const { data: Token } = getTokenRes;

    const productsArray = structuredClone(data);

    let lastVariableProduct = null;
    let lastVariableProductId = null;

    for (const [indexProduct, product] of productsArray.entries()) {

      const productToSave = {
        ...product,
        Token,
      };

      switch (productToSave.type) {
        case "simple":
          lastVariableProduct = null;
          lastVariableProductId = null;

          try {
            updateDataProductStatus(indexProduct, 'Cargando...');
            // Hacer la primera petición para guardar el producto
            const res = await axios.post(baseurl + "GuardarProducto", {
              ...productToSave,
            });
          
            if (res.data.Exito) {
              const simpleProductWC = {
                name: productToSave.Descripcion,
                sku: res.data.CodigoBarras,
                type: productToSave.type,
                regular_price: `${productToSave.PrecioVentaConIva1}`,
                manage_stock: true,
                contable_codes: productToSave.ParametrizacionContableProducto,
                status: "pending",
                sale_price: `${productToSave.PrecioVentaConIva1}`,
                stock_quantity: 0,
                stock_status: "outofstock",
                wholesale_price: {
                  wholesale_customer: productToSave.PrecioVentaConIva2,
                },
                categories: [
                  {
                    id: productToSave.IdCategoria,
                  },
                  {
                    id: productToSave.IdSubCategoria,
                  },
                ],
                meta_data: [
                  {
                    key: "referencia",
                    value: productToSave.Codigo
                  }
                ],
                weight: productToSave.weight,
                brands: [
                  {
                    id: productToSave.brandId
                  }
                ]
              };

              const resWc = await axios.post(`${baseurlwc}/products?${credentials}`, {
                ...simpleProductWC,
              });

              if (resWc.data.id) {
                updateDataProductStatus(indexProduct, res.data.MensajeError);
              }
            } else {
              toast.error(res.data.MensajeError);
              updateDataProductStatus(indexProduct, res.data.MensajeError);
            }
          } catch (error) {
            console.error("Error en la petición:", error);
            toast.error("Hubo un error en la carga del producto.");
            updateDataProductStatus(indexProduct, "Error en la carga del producto.");
          }
          break;

        case "variable":
          lastVariableProduct = product;

          try {
            updateDataProductStatus(indexProduct, 'Cargando...');

            const variableProductWC = {
              sku: productToSave.Codigo,
              name: productToSave.Descripcion,
              type: productToSave.type,
              manage_stock: false,
              status: "pending",
              contable_codes: productToSave.ParametrizacionContableProducto,
              stock_quantity: 0,
              stock_status: "outofstock",
              categories: [
                { id: productToSave.IdCategoria },
                { id: productToSave.IdSubCategoria },
              ],
              weight: productToSave.weight,
              brands: [
                {
                  id: productToSave.brandId
                }
              ],
              attributes: productToSave.attributes
            };

            const res = await axios.post(
              `${baseurlwc}/products?${credentials}`,
              variableProductWC
            );

            if (res.data.id) {
              updateDataProductStatus(indexProduct, 'Producto Guardado con Exito!');
              lastVariableProductId = res.data.id;
            }
          } catch (error) {
            console.error("Error creando producto en WooCommerce:", error);
          }
          break;

          case "variante":
            try {
              updateDataProductStatus(indexProduct, 'Cargando...');

              const varianteProduct = {
                Descripcion: productToSave.Descripcion || lastVariableProduct.Descripcion+"-"+productToSave.attributes.flatMap(item => item.options).join("-"),
                IdCategoria: lastVariableProduct.IdCategoria,
                IdSubCategoria: lastVariableProduct.IdSubCategoria,
                Categoria: lastVariableProduct.Categoria,
                SubCategoria: lastVariableProduct.SubCategoria,
                Codigo: productToSave.Codigo,
                IdIva: productToSave.IdIva,
                PorcentajeIva: productToSave.PorcentajeIva,
                IdMarca: lastVariableProduct.brandId,
                Marca: lastVariableProduct.brandName,
                PrecioVentaConIva1: productToSave.PrecioVentaConIva1,
                PrecioVentaConIva2: productToSave.PrecioVentaConIva2,
                PrecioVentaConIva3: productToSave.PrecioVentaConIva3,
                TipoProducto: productToSave.TipoProducto,
                Token: productToSave.Token,
                productstore: productToSave.productstore,
                weight: productToSave.weight,
              }

              const res = await axios.post(baseurl + "GuardarProducto", {
                ...varianteProduct,
              });

              if (res.data.Exito) {
                const attributes = [
                  {
                    id: 1,
                    option: productToSave.attributes.find(item => item.id === 1).options[0],
                    name: 'Talla',
                    slug: productToSave.attributes.find(item => item.id === 1).options[0],
                  },
                  {
                    id: 2,
                    option: productToSave.attributes.find(item => item.id === 2).options[0],
                    name: 'Color',
                    slug: productToSave.attributes.find(item => item.id === 2).options[0],
                  }
                ];
                
                const varianteProductWC = {
                  attributes,
                  sku: res.data.CodigoBarras,
                  manage_stock: true,
                  price: productToSave.PrecioVentaConIva1,
                  regular_price: String(productToSave.PrecioVentaConIva1),
                  weight: productToSave.weight,
                }

                try {
                  const variationRes = await axios.post(
                    `${baseurlwc}/products/${lastVariableProductId}/variations?${credentials}`,
                    { ...varianteProductWC }
                  );
          
                  if (variationRes.data.id) {
                    updateDataProductStatus(indexProduct, 'Producto Guardado con Exito!');
                  } else {
                    updateDataProductStatus(indexProduct, variationRes.data.message);
                  }
                } catch (error) {
                  updateDataProductStatus(indexProduct, "Error al guardar la variación: " + (error.response?.data?.message || error.message));
                }
              }else{
                updateDataProductStatus(indexProduct, res.data.MensajeError);
              }

            } catch (error) {
              updateDataProductStatus(indexProduct, "Error al guardar la variación: " + (error.response?.data?.message || error.message));
            }
          break;

          default:
          break;
      }
    }

    setLoadingMassive(false);
  };

  return (
    <Content
      style={{ marginLeft: "10vw", marginTop: "10px", overflow: "initial" }}
    >
      <Row justify="center">
        <Card style={stylecard} title={"Cargue masivo de productos"}>
          <Dragger {...props} disabled={loadingMassive}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastra un archivo a esta área para subirlo
            </p>
            <p className="ant-upload-hint">
              Solo se admiten documentos .xlsx de Excel.
            </p>
          </Dragger>

          <div style={{ marginTop: "20px" }}>
            {loading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoadingOutlined style={{ fontSize: 50 }} />
                <p style={{ fontSize: 36, marginBottom: 0 }}>
                  Procesando documento
                </p>
              </div>
            ) : data.length > 0 ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: 20,
                  }}
                >
                  <Button
                    htmlType="button"
                    loading={loadingMassive}
                    type="primary"
                    shape="round"
                    icon={<UploadOutlined />}
                    onClick={massiveUpload}
                  >
                    Cargue Masivo
                  </Button>
                </div>
                <Table dataSource={data} columns={columns} />
              </div>
            ) : (
              <Result status="404" title="No existen datos procesados" />
            )}
          </div>
        </Card>
      </Row>
    </Content>
  );
};
